<template>
    <actions-layout>
        <common-page-header :heading="$t('pages.auth.select_physician.heading')"></common-page-header>

        <common-content-wrapper width="medium">
            <common-member-switch
                :members="$auth.getMembers()"
                :switchToLabel="$t('common.users_list.activate')"
                :isStandalone="true"
            ></common-member-switch>
            <common-content-spacer height="large">
                <button class="button__link" type="button" @click="goToInvitePhysiciansToPractice()">
                    {{ $t('pages.auth.select_physician.invite_other_physicians_link') }} &gt;
                </button>
            </common-content-spacer>
        </common-content-wrapper>
    </actions-layout>
</template>

<script>
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import ActionsLayout from 'components/layouts/ActionsLayout'

    export default {
        mixins: [PageWithDataMixin, PageWithTitleMixin],

        components: {
            ActionsLayout,
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.select_physician.title')
            },
        },
        methods: {
            goToInvitePhysiciansToPractice() {
                this.$router.push({ name: 'auth.invite-member' })
            },
        },
    }
</script>
